import _get from 'lodash/get'

import {
    FOREIGN_INCOME_SAVE_ERROR,
    FOREIGN_INCOME_SAVE_SUCCESS,
    FOREIGN_INCOME_SAVING,
    FOREIGN_INCOME_UPDATE,
} from '../actions'

export default (
    state = {
        shouldFetch: true,
        fetchSuccessful: false,
        activeForeignIncomeIndex: 0,
        activeQuestionIndex: 0,
        foreignIncomeSummary: {
            foreignDomicileRemittanceBasis: null,
            foreignTaxResident: null,
            hasRemittedFunds: null,
            notes: '',
        },
    },
    action
) => {
    switch (action.type) {
        case FOREIGN_INCOME_UPDATE:
            return { ...state, ...action.foreignIncome }

        case FOREIGN_INCOME_SAVING:
            return { ...state, isSaving: true }

        case FOREIGN_INCOME_SAVE_SUCCESS:
            return {
                ...state,
                ...action.foreignIncome,
                isSaving: false,
                goToNextQuestion: true,
                saveError: false,
                errorMessage: '',
                validationErrors: null,
            }

        case FOREIGN_INCOME_SAVE_ERROR:
            return {
                ...state,
                ...action.foreignIncome,
                isSaving: false,
                goToNextQuestion: false,
                saveError: true,
                errorMessage: _get(action, ['errorResponse', 'message'], 'Unknown error occurred'),
                validationErrors: _get(action, ['errorResponse', 'modelState'], false),
            }

        default:
            return state
    }
}
